/* ============================================================
   Yummii — oprydning efter temaets sidebar-lås

   Temaets .site-overlay lægger sig hen over hele siden med 36 %
   sort og tager imod alle klik, så længe <body> har klassen
   sidebar-opened. Den klasse sættes og fjernes udelukkende af
   temaets egen <sidebar-drawer> i section-header.js.

   Butikken bruger den custom yy-cart i stedet for temaets
   kurv-skuffe, og de to kender ikke hinanden. Lukkes en skuffe ad
   en vej temaet ikke selv står for, bliver klassen hængende: der
   er ikke længere noget åbent, men skærmen forbliver mørk — og
   klikkene forsvinder ned i et lag man ikke kan se.

   Her håndhæver vi temaets egen regel: klassen hører kun hjemme
   så længe en skuffe faktisk er åben.

   Vi tester på _opened og ikke på klassen sidebar--opened, fordi
   show() først sætter den klasse 15 ms senere. _opened sættes
   synkront og før body-klassen, så observatøren aldrig når at se
   et ægte åbent panel som forældreløst.
   ============================================================ */
(function () {
  'use strict';

  var LAASEKLASSER = [
    'sidebar-opened',
    'sidebar-opened--left',
    'sidebar-opened--right'
  ];

  /* Temaets egen kurv-skuffe (#site-cart-sidebar) er skjult af yy-cart
     med display:none. "Tilfoej til kurv" paa produktsiden aabner den
     alligevel (usynligt), og saa saetter temaet laaseklasserne. Lukker
     kunden bagefter yy-cart, staar den skjulte skuffe stadig som aaben,
     og skaermen forbliver moerk (meldt igen 13/10 2026). En skjult skuffe
     kan aldrig vaere aaben for kunden, saa vi lukker den med temaets
     egen hide() i samme oejeblik, den aabnes. */
  function skjult(el) {
    return window.getComputedStyle(el).display === 'none';
  }

  function skuffeAaben() {
    var aaben = false;
    var skuffer = document.querySelectorAll('sidebar-drawer');
    for (var i = 0; i < skuffer.length; i++) {
      var s = skuffer[i];
      if (s._opened !== true) continue;
      if (skjult(s)) {
        try { s.hide(); } catch (e) { s._opened = false; s.classList.remove('sidebar--opened'); }
        continue;
      }
      aaben = true;
    }
    return aaben;
  }

  function ryd() {
    if (!document.body.classList.contains('sidebar-opened')) return;
    if (skuffeAaben()) return;
    LAASEKLASSER.forEach(function (klasse) {
      document.body.classList.remove(klasse);
    });
  }

  /* At fjerne klassen udløser observatøren igen, men anden gang er
     klassen væk og ryd() falder fra på første linje. */
  new MutationObserver(ryd).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  ryd();
}());
